(function(){
  'use strict';
  var context=window.PTNewsletterPreferences;
  if(!context)return;
  var template=document.getElementById('pt-pref-template');
  if(!template)return;
  document.body.appendChild(template.content.cloneNode(true));
  var dialog=document.getElementById('pt-preferences');
  var token=context.token;delete context.token;
  var $=function(id){return document.getElementById('pt-pref-'+id);};
  var busy=false,canResubscribe=true;
  function show(id){
    ['before','after','confirmed','error'].forEach(function(name){$(name).hidden=name!==id;});
    $('status').textContent='';$(id).focus();dialog.scrollTop=0;
  }
  async function api(action,data){
    var response=await fetch('https://partner.planet-tree.de/api2/newsletter/preferences/'+action,{
      method:'POST',credentials:'omit',referrerPolicy:'no-referrer',headers:{'Content-Type':'application/json'},
      body:JSON.stringify(Object.assign({token:token},data||{}))
    });
    var result=await response.json();
    if(!response.ok)throw new Error(typeof result.detail==='string'?result.detail:'Bitte versuche es gleich noch einmal.');
    return result;
  }
  async function run(button,work){
    if(busy)return;busy=true;if(button)button.disabled=true;
    $('status').textContent='Einen Moment bitte …';
    try{await work();}catch(error){$('status').textContent=error.message||'Die Verbindung ist gerade unterbrochen. Bitte versuche es erneut.';}
    finally{busy=false;if(button)button.disabled=false;}
  }
  dialog.addEventListener('cancel',function(event){event.preventDefault();location.href='https://planet-tree.de/';});
  dialog.showModal();document.title='Deine Waldpost · Planet Tree';
  $('unsubscribe').onclick=function(){run(this,async function(){
    var result=await api('unsubscribe');canResubscribe=result.can_resubscribe;
    $('again').closest('.secondary').hidden=!canResubscribe;show('after');
  });};
  $('again').onclick=function(){if(!canResubscribe)return;run(this,async function(){await api('resubscribe',{consent:true});show('confirmed');});};
  async function initialize(){
    if(!token){show('error');return;}
    try{
      if(context.mode==='confirm'){
        $('status').textContent='Deine erneute Anmeldung wird bestätigt …';
        await api('confirm');show('confirmed');
      }else{
        var result=await api('status');canResubscribe=result.can_resubscribe;
        $('again').closest('.secondary').hidden=!canResubscribe;
        show(result.state==='unsubscribed'?'after':'before');
      }
    }catch(error){show('error');$('status').textContent=error.message;}
  }
  initialize();
})();
